import React from "react";
import { BsCodeSlash } from "react-icons/bs";
import { FcMultipleDevices } from "react-icons/fc";
import { TbDeviceDesktopAnalytics } from "react-icons/tb";

const MyServices = () => {
  return (
    <div className="my-8 lg:px-20 mb-20 w-full mx-auto items-center text-white shadow-lg">
      <h2 className="text-5xl text-center mb-10 font-bold text-pink-700">
        What I Do ?{" "}
      </h2>
      <div className="items-center grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-5 py-8">
        <div data-aos="zoom-in-right" data-aos-delay="1" className="card w-80 mx-auto border-8 grid border-x-slate-700 bg-gray-700 shadow-xl">
          <div className="card-body items-center justify-around">
            <span className="text-5xl text-sky-700 font-bold">
              <BsCodeSlash />
            </span>
            <span className="card title text-2xl text-center font-bold ">
              Front end Development{" "}
            </span>
          </div>
        </div>
        <div data-aos="zoom-in-up" data-aos-delay="2" className="card w-80 mx-auto border-8 grid border-x-slate-700 bg-gray-700 shadow-xl">
          <div className="card-body items-center justify-around">
            <span className="text-5xl text-sky-700 font-bold">
              <FcMultipleDevices />
            </span>
            <span className="card title text-2xl text-center font-bold">
              Full Stack Development
            </span>
          </div>
        </div>
        <div data-aos="zoom-in-left" data-aos-delay="3" className="card w-80 mx-auto border-8 grid border-x-slate-700 bg-gray-700 shadow-xl">
          <div className="card-body items-center justify-around">
            <span className="text-5xl text-sky-700 font-bold">
              <TbDeviceDesktopAnalytics />
            </span>
            <span className="card title text-2xl text-center font-bold">
              MERN Stack Development
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyServices;
